import {SimpleQueryFiltersResource} from './simpleQueryFiltersResource.model';

export class SimpleEventsQueryResource {
    startDateISO: string;
    endDateISO: string;
    calendars: Array<string>;
    queryFilters: SimpleQueryFiltersResource;

    constructor(map: SimpleEventsQueryResource = {} as SimpleEventsQueryResource) {
        this.startDateISO = map.startDateISO || null;
        this.endDateISO = map.endDateISO || null;
        this.calendars = map.calendars || [];
        this.queryFilters = map.queryFilters || null;
    }
}
